'use strict';

/**
 * @fileoverview `@puffin-core/whole-number` — the ONE readable-count rule (REDS expiry-fails-closed item 46).
 *
 * "Is this a count I can read?" was answered by seven private copies, two of them unsafe:
 * - device-pin-vault, prospect-api's attachment refusals, app-catalog's public catalog, auth-routes' dashboard groups and
 *   labor-metrics' summed amounts asked `Number.isInteger`, which accepts 2^53 and beyond: integers past the safe range
 *   that cannot be counted exactly;
 * - shipping-pricing and response-helpers asked `Number.isSafeInteger`.
 *
 * And a count compared with a limit it could not read answered "within": `undefined >= max` is false, so a key with no
 * readable use count, or a coupon with no readable cap, kept working. The rule here is the one every reader asks before
 * it compares: a non-negative SAFE integer, nothing else.
 *
 * - `null` is not a whole number. Whether a NULL column means "no limit" is the CALLER's decision, said at its call site
 *   (`limit !== null && …`), never this rule's.
 * - A digit string is not a whole number. A wire form (PostgreSQL answers a bigint COUNT as text) is translated by its
 *   reader, as its own step, before it asks this rule.
 *
 * Pure, zero dependencies; dual-use (CJS source, GENERATED ESM re-export).
 *
 * @module @puffin-core/whole-number
 */

/**
 * @param {*} value
 * @returns {boolean} Whether the value is a non-negative safe integer: 0, 1, 2, … up to `Number.MAX_SAFE_INTEGER`.
 */
function isWholeNumber(value) {
  return Number.isSafeInteger(value) && value >= 0;
}

module.exports = { isWholeNumber };
